import React from 'react';
import FadeUp from '../ui/FadeUp';

export default function HowItWorks() {
  const steps = [
    { num: '01', title: 'Call or Text', desc: 'Reach us at <strong>443-359-2010</strong> for a fast, free quote. No pressure, no commitment.' },
    { num: '02', title: 'Schedule', desc: 'Pick a time that works for you. Same-day and next-day appointments often available.' },
    { num: '03', title: 'We Remove', desc: 'Our crew arrives, does all the heavy lifting, and clears everything out cleanly.' },
    { num: '04', title: 'Enjoy!', desc: 'You get your space back — clean, clear, and ready for what\'s next.' },
  ];

  return (
    <section id="how-it-works" className="section-padding">
      <FadeUp className="text-center max-w-[600px] mx-auto">
        <div className="font-condensed text-xs font-bold tracking-[0.2em] uppercase text-gold mb-4">Simple Process</div>
        <h2 className="font-condensed font-black text-[clamp(36px,4vw,56px)] uppercase leading-none mb-5">How It Works</h2>
        <p className="text-text-muted text-[17px] leading-relaxed">
          We've made junk removal as easy as a phone call. Here's what to expect:
        </p>
      </FadeUp>

      <FadeUp className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mt-16 border border-dark-4">
        {steps.map((step, i) => (
          <div key={i} className="group p-12 lg:border-r border-b lg:border-b-0 border-dark-4 last:border-r-0 last:border-b-0 relative transition-colors hover:bg-dark-2">
            <div className="font-condensed text-7xl font-black leading-none text-gold/15 mb-5 transition-colors group-hover:text-gold/30">
              {step.num}
            </div>
            <div className="font-condensed font-extrabold text-[22px] uppercase mb-3 text-text">
              {step.title}
            </div>
            <div className="text-[15px] text-text-muted leading-relaxed" dangerouslySetInnerHTML={{ __html: step.desc }} />
          </div>
        ))}
      </FadeUp>
    </section>
  );
}